import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import { selectDepartmentById } from '../features/departments/departmentsSlice';
import useTrackingHandler from './useTrackingHandler';

const ICON_WRAPPER_CLASSES =
	'icon-wrapper d-flex flex-column align-items-center justify-content-center text-link text-decoration-none';

// This hook return the attributes needed for the link or button,
// based on (1) the zero-based index (0 being left-most) as the buttons appear visually,
// and (2) whether the component renders within the modal or not.
export const useContactBtnLinks = (
	isWithinModal = false,
	index = 0,
	iconName = '',
	departmentId = ''
) => {
	const labels = useLabels();
	const department = useSelector((state) =>
		selectDepartmentById(state, departmentId)
	);

	const [handler] = useTrackingHandler(
		iconName,
		labels.get(department.label)
	);

	const btnAttributes = {};
	if (!isWithinModal) {
		btnAttributes.className = ICON_WRAPPER_CLASSES;
		btnAttributes.style = { fontSize: '24px' };
	} else if (isWithinModal && index < 2) {
		btnAttributes.className = `btn ${
			index === 1 ? 'border-primary text-primary' : 'btn-primary'
		} rounded`;
		btnAttributes.role = 'button';
	}

	const iconClasses = ['ddc-icon', `ddc-icon-${iconName}`];
	return [btnAttributes, iconClasses.join(' ').trim(), handler];
};
